import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getComparisonCampaignsReportsStats,
} from './comparison-campaigns.state';

export const withComparisonCampaigns = connect(
    state => ({
        comparisonCampaigns: state.comparisonCampaigns,
    }),
    dispatch => bindActionCreators({
        getComparisonCampaignsReportsStats,
    }, dispatch),
);
